export enum CashRegisterType {
  Open = 'open',
  Close = 'close',
}
